import { Box, Typography } from '@atgfr8/atg-ui-tailwind';
import SectionCard from '@mobileComponents/SectionCard';
import { customerDetailsStore } from '@mobileStore/customer';
import { CustomerOrderSummary } from '@typeDefinitions/customerTypes';
import { formatAmount } from '@utils/utils';
import { For } from 'solid-js';

const OrderSummary = () => {
  const orderSummary = () => customerDetailsStore.customer.orderSummary || [];

  const OrderRow = (props: {
    count: number;
    status: string;
    amount: string;
  }) => (
    <Box class="flex items-center justify-between p-1 border border-gray-200  bg-[#ECEFF1]! rounded-sm mb-1">
      <Box
        class={
          'flex items-center justify-center min-w-7 min-h-7 px-1.5 rounded-full bg-[#123B50] text-white font-semibold text-sm'
        }
      >
        {props.count}
      </Box>
      <Typography class="flex-1 ml-4! text-[16px] font-medium">
        {props.status}
      </Typography>
      <Typography class="text-[16px] font-semibold text-[#28957C]">
        {props.amount}
      </Typography>
    </Box>
  );

  return (
    <SectionCard title="Order Summary">
      <Box class="p-2">
        <For each={orderSummary()}>
          {(item: CustomerOrderSummary) => (
            <OrderRow
              count={item.orders}
              status={item.status}
              amount={formatAmount(item.amount)}
            />
          )}
        </For>
        {orderSummary().length === 0 && (
          <Box class="text-center py-6 text-gray-500">
            <Typography class="text-[16px]">
              No order summary available
            </Typography>
          </Box>
        )}
      </Box>
    </SectionCard>
  );
};

export default OrderSummary;
